import { MilanoteApplicationMode } from '../../../../common/platform/platformTypes';
import { COLLAPSE_ORDER, TOOL_HEIGHT } from '../../../workspace/toolbar/config/toolbarToolConfigConstants';

// oxlint-disable no-restricted-imports -- This bridge lazily loads table tools into the tables code-split chunk.
// TABLE IMPORT: This is one of two places where the table chunk gets imported -- other is in element/table/index.tsx
import AddColumnTool from '../module/tools/AddColumnTool';
import AddRowTool from '../module/tools/AddRowTool';
import CellTypeTool from '../module/tools/CellTypeTool';
import MobileCellTypeFormatTool from '../module/tools/MobileCellTypeFormatTool';
import MobileCellTypeTool from '../module/tools/MobileCellTypeTool';
import MobileTableCellAlignmentTool from '../module/tools/MobileTableCellAlignmentTool';
import MobileTableCellColorTool from '../module/tools/MobileTableCellColorTool';
import MobileTableTextStyleRichTextTool from '../module/tools/MobileTableTextStyleRichTextTool';
import TableCellAlignmentTool from '../module/tools/TableCellAlignmentTool';
import TableCellColorTool from '../module/tools/TableCellColorTool';
import TableCellFormulaTool from '../module/tools/TableCellFormulaTool';
import TableContextMenuTool from '../module/tools/TableContextMenuTool';
import TableTextStyleTool from '../module/tools/TableTextStyleTool';

import type { ToolbarItemConfig } from '../../../workspace/toolbar/toolbarTypes';

const TABLE_CELL_ALIGNMENT: ToolbarItemConfig = {
    id: 'TABLE_CELL_ALIGNMENT',
    name: 'Alignment',
    localeKey: 'tools.editing.table.alignment',
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    component: TableCellAlignmentTool,
    mobileComponent: MobileTableCellAlignmentTool,
    appModeAvailability: [MilanoteApplicationMode.desktop, MilanoteApplicationMode.mobile],
};

const TABLE_TEXT_STYLES: ToolbarItemConfig = {
    id: 'TABLE_TEXT_STYLES',
    name: 'Text style',
    localeKey: 'tools.editing.textStyle',
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.LATE,
    component: TableTextStyleTool,
    mobileComponent: MobileTableTextStyleRichTextTool,
    appModeAvailability: [MilanoteApplicationMode.desktop, MilanoteApplicationMode.mobile],
};

const TABLE_CELL_FORMULA: ToolbarItemConfig = {
    id: 'TABLE_CELL_FORMULA',
    name: 'Formula',
    localeKey: 'tools.editing.table.formula',
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    component: TableCellFormulaTool,
    appModeAvailability: [MilanoteApplicationMode.desktop, MilanoteApplicationMode.mobile],
};

const TABLE_CELL_TYPE: ToolbarItemConfig = {
    id: 'TABLE_CELL_TYPE',
    name: 'Cell type',
    localeKey: 'tools.editing.table.cellType',
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.NEVER,
    component: CellTypeTool,
    mobileComponent: MobileCellTypeTool,
    appModeAvailability: [MilanoteApplicationMode.desktop, MilanoteApplicationMode.mobile],
};

const TABLE_CELL_TYPE_FORMAT: ToolbarItemConfig = {
    id: 'TABLE_CELL_TYPE_FORMAT',
    name: 'Format',
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.NEVER,
    component: MobileCellTypeFormatTool,
    appModeAvailability: [MilanoteApplicationMode.mobile],
};

const TABLE_CELL_COLOR: ToolbarItemConfig = {
    id: 'TABLE_CELL_COLOR',
    name: 'Cell Color',
    localeKey: 'tools.editing.table.cellColor',
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.NEVER,
    component: TableCellColorTool,
    mobileComponent: MobileTableCellColorTool,
    appModeAvailability: [MilanoteApplicationMode.desktop, MilanoteApplicationMode.mobile],
};

const TABLE_ADD_COLUMN: ToolbarItemConfig = {
    id: 'TABLE_ADD_COLUMN',
    name: 'Add column',
    localeKey: 'tools.editing.table.addColumn',
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    component: AddColumnTool,
    appModeAvailability: [MilanoteApplicationMode.desktop, MilanoteApplicationMode.mobile],
};

const TABLE_ADD_ROW: ToolbarItemConfig = {
    id: 'TABLE_ADD_ROW',
    name: 'Add row',
    localeKey: 'tools.editing.table.addRow',
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    component: AddRowTool,
    appModeAvailability: [MilanoteApplicationMode.desktop, MilanoteApplicationMode.mobile],
};

const TABLE_CONTEXT_MENU: ToolbarItemConfig = {
    id: 'TABLE_CONTEXT_MENU',
    name: 'More',
    localeKey: 'tools.selected.more',
    height: {
        large: 16,
        medium: 16,
        small: 14,
    },
    collapseOrder: COLLAPSE_ORDER.NEVER,
    component: TableContextMenuTool,
    appModeAvailability: [MilanoteApplicationMode.desktop],
};

export default {
    TABLE_CELL_ALIGNMENT,
    TABLE_TEXT_STYLES,
    TABLE_CELL_FORMULA,
    TABLE_CELL_TYPE,
    TABLE_CELL_TYPE_FORMAT,
    TABLE_CELL_COLOR,
    TABLE_ADD_COLUMN,
    TABLE_ADD_ROW,
    TABLE_CONTEXT_MENU,
} as const;
